interface PillLayout {
  readonly x: number;
  readonly width: number;
}

interface PillsViewport {
  readonly offset: number;
  readonly width: number;
}

interface ScrollOffsetToRevealPillFunctionArgs {
  readonly pill: PillLayout | undefined;
  readonly viewport: PillsViewport;
  readonly margin: number;
}

const scrollOffsetToRevealPill = ({
  pill,
  viewport,
  margin,
}: ScrollOffsetToRevealPillFunctionArgs): number | undefined => {
  if (!pill || !viewport.width) {
    return undefined;
  }

  const isVisible = pill.x >= viewport.offset && pill.x + pill.width <= viewport.offset + viewport.width;

  return isVisible ? undefined : Math.max(0, pill.x - margin);
};

interface InitialScrollOffsetFunctionArgs {
  readonly pill: PillLayout | undefined;
  readonly index: number;
  readonly margin: number;
}

const initialScrollOffset = ({ pill, index, margin }: InitialScrollOffsetFunctionArgs): number | undefined =>
  pill && index > 0 ? pill.x + margin : undefined;

export type { PillLayout, PillsViewport };
export { initialScrollOffset, scrollOffsetToRevealPill };
